import { useTypedSelector } from './useTypedSelector'

export const useRootLink = () => {
  const { token, inLoading } = useTypedSelector((state) => state.authReducer)

  if (inLoading) {
    return null
  }

  if (token) {
    return { to: '/order', search: { page: 1, perPage: 10 } }
  }

  return { to: '/auth' }
}
